import { QueryClient } from '@tanstack/react-query';

// frontend-restructuring §0.8d — React Query defaults.
//
// `refetchOnWindowFocus: false` is deliberate: many feature lists (tasks, map presence, mail)
// are kept live by socket events + optimistic updates. RQ5's default (`true`) would silently
// refetch on every tab refocus and replace the cache with server state, discarding pending
// optimistic edits and drag positions. A feature hook that genuinely wants focus-refetch opts
// back in per-query.
//
// `staleTime` 30s = don't refetch on remount within 30s (unchanged). `gcTime` 5min = keep an
// unused query in cache 5min before dropping it (RQ default, set explicitly). A socket-synced
// list overrides these with `staleTime: Infinity` in its own hook.
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 1,
            staleTime: 30_000,
            gcTime: 5 * 60_000,
            refetchOnWindowFocus: false,
        },
    },
});
